import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, type = 'website' }) => {
  const location = useLocation();
  const canonicalUrl = `https://sireetuitions.com${location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Google Search Console Verification */}
      {process.env.REACT_APP_GSC_VERIFICATION_CODE && (
        <meta name="google-site-verification" content={process.env.REACT_APP_GSC_VERIFICATION_CODE} />
      )}

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "EducationalOrganization",
          "name": "Siree Academy & Home Tuitions",
          "url": "https://sireetuitions.com",
          "logo": "https://sireetuitions.com/logo.png",
          "description": "Personalized one-on-one home tuition for Science and Mathematics in Hyderabad.",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Hyderabad",
            "addressRegion": "Telangana",
            "addressCountry": "IN"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-9391647597",
            "contactType": "customer service"
          },
          "founder": {
            "@type": "Person",
            "name": "Boda Sireesha"
          }
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
